module.exports = __webpack_public_path__ + "static/media/sleepwear-alt.3bd06d91.svg";